import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Tropical forests, with rich biodiversity, constitute vital
              livelihood-supporting ecosystems across the globe. Forest
              ecosystems worldwide are the most threatened ecosystems with
              unplanned developmental activities leading to land cover changes
              and over-exploitation of natural resources due to
              industrialization during the last century and globalization in the
              recent past (Nayak et al. 2020; Ramachandra et al. 2020a; Brinck
              et al. 2017). This necessitates to minimise anthropogenic
              pressures to avoid crossing planetary boundaries from climate
              change through large-scale land cover changes.
            </p>
            <p>
              Land use land cover (LULC) changes in a forest landscape have been
              posing severe challenges for conservation due to the fragmentation
              of native forests, and rapid degradation resulting in
              deforestation with a sustained burden on the ecosystem(Ramachandra
              et al. 2016b; Langlois et al. 2017; Ramachandra et al. 2019a;
              Ewers and Banks-Leite 2013; Chaplin-Kramer et al. 2015; Hunter et
              al. 2015; Latimer and Zuckerberg 2017; Andronache et al. 2019;
              Ramachandra and Bharath 2021).Unregulated exploitation of forest
              resources and LULC changes have led to the degradation of the
              unique ecological units, evident from barren hilltops and
              fragmented forest patches (Ramachandra and Bharath 2019c),
              affecting hydrological services such as the conversion of
              perennial streams to intermittent ones, and loss of groundwater
              recharge potential, loss of livelihood opportunities (Banerjee and
              Madhurima 2013), reduction in productivity (Nayak et al. 2012),
              alteration in surface and ambient temperature, etc. (Bharath et
              al. 2013; Bharath et al. 2021; Koschke et al. 2012; Ramachandra et
              al. 2017a; Ramachandra et al. 2018b;Ramachandra et al. 2019b).
            </p>
            <p>
              Integrated analyses considering the demographic, ecological,
              climatic, economic, market, and institutional factors help
              formulate prudent natural resources management strategies. Forest
              land management policies incorporating the perceptions of all
              stakeholders would aid in understanding driving forces, impacts,
              and remedial measures for improved livelihood strategies.
            </p>
            <p>
              Conservation planning approaches to protect the regions of
              ecological significance require appropriate technologies, an
              understanding of social-ecological systems, and opportunity costs
              of economic relevance. Considering the ecological system is
              crucial for sustainable development to support human activities
              with social and economic development, as per tenets of the
              Sustainable Development Goals (SDGs) (United Nations 2015; Brinck
              et al. 2017; Bharath and Ramachandra 2021). Identifying landscape
              elements or regions of distinct characteristics that have low
              resilience and, if disturbed by external influences, either
              anthropogenic or natural, will be difficult to restore to their
              natural state(Gadgil et al. 2011)is crucial. These identified
              regions at disaggregated levels are known as Ecologically
              Sensitive Regions/Areas/Zones (ESR/ESA/ESZ) or ecologically
              fragile regions (EFR).Hence, ESR or EFR constitutes the regions of
              diverse landforms, vegetation, geology, and rich biodiversity
              characterized by their sensitivity and economically significant
              for providing services. Conservation of ESR is vital for the
              long-term sustenance of biological diversity, soil, water, or
              other natural resources in the landscape/region. ESR framework
              prioritizes the inherent significance of a region, trade‐offs
              involved due to conservation actions and informs of consequences
              in the current management activities(Ramachandra et al. 2017b).
              ESR supports comprehensive ecological conservation by conserving
              the most ecologically valuable and fragile ecosystems and guiding
              nature conservation. ESR identification accounts for the dynamic
              interactions among biodiversity, geo-climatic and social
              processes. The Ministry of Environment Forest and Climate Change
              (MoEFCC), the Government of India, is empowered to frame the
              conservation and environmental protection policies under section 3
              of the Environmental Protection Act 1986 (EPA). The Ministry has
              the legal capabilities to prohibit environmentally hazardous or
              polluting industries as per section 5 of EPA. MoEFCC in 2000
              constituted an expert committee (Pronab Sen committee: 2000) to
              provide guidelines to identify regions based on their ecological
              significance(MOEF 2000). In this regard, the Western Ghats Ecology
              Experts Panel constituted by MoEFCC (in 2011) prescribed
              conservation and management measures in the ecologically
              &lsquo;salient&rsquo; regions at the taluk (tehsil- a local
              administrative unit) level. High-Level Working Group, formed in
              2013, demarcated ESA (Ecologically Sensitive Areas) through
              geospatial analysis but failed to account for the social dynamics
              and the role of local ecology in sustaining the ecosystem
              services. However, both reports have not been implemented yet.
            </p>
            <p>
              <strong>Objectives</strong>
            </p>
            <p>
              Policies for conserving biodiversity in the hottest hotspot
              regions, such as the Western Ghats (WG) require the demarcation of
              critical ecological, hydrological, and social regions by
              integrating a technologically advanced approach, considering
              ecologically or economically significant and sensitive variables,
              coupled with multi-criteria analysis. In this regard, the
              objectives of the current research are (i) assessment of the
              spatial extent of ecosystems, (ii) elucidation of ecosystem
              conditions through the understanding of LULC dynamics with the
              extent of fragmentation of forests; (iii) integrating
              bio-geo-climatic and social variables at disaggregated levels and
              (iv) demarcation of ecologically fragile regions or ecologically
              sensitive regions (ESR) at disaggregated levels through effective
              integration of bio-geo-climatic, hydrological, ecological and,
              social dynamics. ESR aids as an effective policy instrument in the
              decision-making (through BMC: Biodiversity Management Committees)
              at decentralized levels (panchayat) to sustain water, food, and
              fodder with sustainable development and support the livelihood of
              all stakeholders.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
